const breakpoints = {
  xs: '0px',
  sm: '600px',
  md: '1024px',
  lg: '1440px',
  xl: '1800px',
}

export default function(el, binding) {
  let sizes = binding.value
  if(!sizes) return ''
  el.sizes = Object.keys(sizes).sort((a,b) => parseInt(breakpoints[a]) - parseInt(breakpoints[a]))
    .reverse()
    .map(key => `(min-width: ${breakpoints[key]}) ${sizes[key]}vw`)
    .concat([`100vw`])
    .join(',')
}